<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth" persistent :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card>
        <div class="pos-abs-fixed">
          <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
            {{ computedTitle }}
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn flat fab small icon @click="$emit('input')" slot="activator">
                <v-icon>close</v-icon>
              </v-btn>
              <span>Cancelar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                color="primary"
                fab
                dark
                small
                @click="adiciona"
                :loading="loading"
                slot="activator"
              >
                <v-icon>done</v-icon>
              </v-btn>
              <span>Salvar</span>
            </v-tooltip>
          </v-card-title>
        </div>

        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout wrap>
              <!-- Tags -->
              <v-flex xs12>
                <v-layout wrap>
                  <div>
                    <h6 class="subheading">Status</h6>
                    <v-chip dark :color="statusColor">
                      {{ statusText }}
                    </v-chip>
                  </div>
                  <div v-if="clienteTags.length">
                    <h6 class="subheading">Tags</h6>
                    <v-chip @input="excluiTag(tag)" close v-for="tag in clienteTags" :key="tag.IdTag">
                      {{ tag.Descricao }}
                    </v-chip>
                  </div>
                  <div v-if="clienteProjetos.length">
                    <h6 class="subheading">Projetos</h6>
                    <v-chip 
                      v-for="projeto in clienteProjetos"
                      :key="projeto.IdProjeto"
                      @click.stop="$emit('abreModalInfoProjeto', projeto)"
                      :color="corStatus(projeto.Status)"
                      dark
                    >
                      {{ projeto.Projeto }}
                    </v-chip>
                  </div>
                </v-layout>
              </v-flex>
              <!-- Identificação -->
              <v-flex xs12>
                <span class="subheading font-weight-medium">Identificação</span>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 md9>
                <v-radio-group v-model="computedTipoPessoa" row hide-details>
                  <v-radio label="Física" value="F" color="primary"></v-radio>
                  <v-radio label="Jurídica" value="J" color="primary"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="cliente.RazaoSocial"
                  label="Razão Social"
                  prepend-icon="folder"
                  hide-details
                  :rules="[rules.required]"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="cliente.Fantasia"
                  label="Nome Fantasia"
                  prepend-icon="folder"
                  hide-details
                  :rules="[rules.required]"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="cliente.CpfCnpj"
                  label="CPF/CNPJ"
                  :mask="cpfCnpjMask"
                  return-masked-value
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="cliente.RgIe"
                  label="RG/IE"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="cliente.InscricaoMunicipal"
                  label="Inscrição Municipal"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="cliente.OrgaoExpedidor"
                  label="Orgão Expedidor"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="cliente.Contato"
                  label="Contato"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <!-- Endereço -->
              <v-flex xs12 pt-3>
                <v-layout :column="$vuetify.breakpoint.smAndDown">
                  <v-flex xs8 md6>
                    <span class="subheading font-weight-medium">Endereço</span>
                  </v-flex>
                  <v-flex xs12 md4 v-if="cliente.IdCliente">
                    <v-autocomplete 
                      v-model="clienteEndereco.Titulo"
                      :items="clienteEnderecos"
                      item-text="Titulo"
                      return-object
                      menu-props="auto"
                      label="Endereço"
                      hide-details
                      auto-select-first
                      cache-items
                      no-data-text="Registro não encontrado."
                      prepend-icon="folder"
                      @change="changeEndereco"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs4 md2 align-self-end v-if="cliente.IdCliente">
                    <v-menu bottom left slot="activator">
                      <v-btn flat fab icon small slot="activator">
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                      <v-list dense>
                        <v-list-tile @click="$emit('deleteEndereco')" class="cursor-pointer">
                          <v-list-tile-title>
                            <v-icon small class="pr-1">delete</v-icon>Excluir
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                    <v-tooltip bottom v-if="true">
                      <v-btn fab dark small color="primary" @click="addNewEndereco" slot="activator">
                        <v-icon dark>add</v-icon>
                      </v-btn>
                      <span>Novo Endereço</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete 
                  v-model="clienteEndereco.Titulo"
                  :items="tiposEndereco"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Tipo Endereço"
                  hide-details
                  auto-select-first
                  cache-items
                  no-data-text="Registro não encontrado."
                  prepend-icon="folder"
                  @change="changeTipoEndereco"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="clienteEndereco.Titulo"
                  label="Titulo"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  v-model="clienteEndereco.Cep"
                  label="CEP"
                  prepend-icon="place"
                  :hide-details="!buscaCepErro"
                  counter="8"
                  id="cep"
                  mask="#####-###"
                  :loading="buscaCepLoading"
                  :hint="buscaCepRetorno"
                  :persistent-hint="buscaCepErro"
                  :rules="[rules.cep]"
                  @keyup.enter="buscaCep"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md7>
                <v-text-field
                  v-model="clienteEndereco.Endereco"
                  label="Endereço"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md2>
                <v-text-field
                  v-model="clienteEndereco.Numero"
                  label="Numero"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="clienteEndereco.Complemento"
                  label="Complemento"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="clienteEndereco.PontoReferencia"
                  label="Ponto Referência"
                  prepend-icon="folder"
                  hide-details
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete 
                  v-model="clienteEndereco.Bairro"
                  :items="bairrosAtivo"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Bairro"
                  hide-details
                  auto-select-first
                  cache-items
                  no-data-text="Registro não encontrado."
                  prepend-icon="folder"
                  @change="changeBairro"
                  @focus="fetchBairros"
                  @click="fetchBairros"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete 
                  v-model="clienteEndereco.Cidade"
                  :items="cidades"
                  item-text="Descricao"
                  return-object
                  menu-props="auto"
                  label="Cidade"
                  hide-details
                  auto-select-first
                  cache-items
                  no-data-text="Registro não encontrado."
                  prepend-icon="folder"
                  @change="changeCidade"
                  @focus="fetchCidades"
                  @click="fetchCidades"
                ></v-autocomplete>
              </v-flex>
              <!-- Telefones -->
              <v-flex xs12 pt-3>
                <v-layout row align-center>
                  <span class="subheading font-weight-medium">Telefones</span>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom v-if="!inputTelefone">
                    <v-btn fab dark small color="primary" @click="mostraInputTelefone" slot="activator">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                    <span>Novo Telefone</span>
                  </v-tooltip>
                </v-layout>
                <v-divider></v-divider>
              </v-flex>
              <!-- Input Telefone -->
              <v-flex xs12 v-if="inputTelefone">
                <v-layout row :column="$vuetify.breakpoint.smAndDown">
                  <v-flex xs12 md3>
                    <v-autocomplete 
                      v-model="clienteTelefone.TipoTelefone"
                      :items="tiposTelefone"
                      item-text="Descricao"
                      menu-props="auto"
                      label="Tipo Telefone"
                      hide-details
                      auto-select-first
                      cache-items
                      no-data-text="Registro não encontrado."
                      prepend-icon="folder"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      v-model="clienteTelefone.Descricao"
                      label="Telefone"
                      hide-details
                      :mask="telefoneMask"
                      return-masked-value
                      prepend-icon="phone"
                      id="telefone-add-item"
                      :rules="[rules.required]"
                      @keyup.enter="adicionaTelefone"
                      @keyup.esc="inputTelefone = false"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      v-model="clienteTelefone.Contato"
                      label="Contato"
                      hide-details
                      prepend-icon="person"
                      :rules="[rules.required]"
                      @keyup.enter="adicionaTelefone"
                      @keyup.esc="cancelaEditaTelefone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md2 align-self-end>
                    <v-tooltip bottom>
                      <v-btn fab flat small @click="cancelaEditaTelefone" slot="activator">
                        <v-icon>close</v-icon>
                      </v-btn>
                      <span>Cancelar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-btn fab dark small color="primary" icon @click="adicionaTelefone" slot="activator">
                        <v-icon>done</v-icon>
                      </v-btn>
                      <span>Salvar</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- Fim Input Telefone -->
              <!-- Lista Telefones -->
              <v-flex xs12>
                <v-list two-line>
                  <template v-for="(telefone, index) in computedClienteTelefones">
                    <v-list-tile :key="telefone.IdClienteTelefone || index" avatar>
                      <v-list-tile-avatar v-if="$vuetify.breakpoint.mdAndUp">
                        <v-icon class="grey lighten-1">phone</v-icon>
                      </v-list-tile-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title>{{ telefone.Descricao }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ telefone.Contato }}</v-list-tile-sub-title>
                        <span class="caption font-italic">{{ tipoTelefoneTexto(telefone.TipoTelefone) }}</span>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-layout row>
                          <v-tooltip bottom v-if="telefone.IdClienteTelefone">
                            <v-btn icon flat small class="mx-0" slot="activator" @click="editaTelefone(telefone)">
                              <v-icon small>edit</v-icon>
                            </v-btn>
                            <span>Alterar</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <v-btn icon flat small class="mx-0" slot="activator" @click="deletaTelefone(telefone)">
                              <v-icon small>delete</v-icon>
                            </v-btn>
                            <span>Excluir</span>
                          </v-tooltip>
                        </v-layout>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < clienteTelefones.length"
                      :key="`${index}-${telefone.IdClienteTelefone}`"
                    ></v-divider>
                  </template>
                </v-list>
              </v-flex>
              <!-- Fim Lista Telefones -->
              <!-- E-mails -->
              <v-flex xs12 pt-3>
                <v-layout row align-center>
                  <span class="subheading font-weight-medium">E-mails</span>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom v-if="!inputEmail">
                    <v-btn fab dark small color="primary" @click="mostraInputEmail" slot="activator">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                    <span>Novo E-mail</span>
                  </v-tooltip>
                </v-layout>
                <v-divider></v-divider>
              </v-flex>
              <!-- Input E-mail -->
              <v-flex xs12 v-if="inputEmail">
                <v-layout row :column="$vuetify.breakpoint.smAndDown">
                  <v-flex xs12 md3>
                    <v-autocomplete 
                      v-model="clienteEmail.Tipo"
                      :items="tiposEmail"
                      item-text="Descricao"
                      menu-props="auto"
                      label="Tipo E-mail"
                      hide-details
                      auto-select-first
                      cache-items
                      no-data-text="Registro não encontrado."
                      prepend-icon="folder"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-text-field
                      v-model="clienteEmail.Descricao"
                      label="E-mail"
                      hide-details
                      prepend-icon="mail"
                      id="email-add-item"
                      :rules="[rules.required, rules.email]"
                      @keyup.enter="adicionaEmail"
                      @keyup.esc="inputEmail = false"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md2 align-self-end>
                    <v-tooltip bottom>
                      <v-btn fab flat small @click="cancelaEditaEmail" slot="activator">
                        <v-icon>close</v-icon>
                      </v-btn>
                      <span>Cancelar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-btn fab dark small color="primary" icon @click="adicionaEmail" slot="activator">
                        <v-icon>done</v-icon>
                      </v-btn>
                      <span>Salvar</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- Fim Input E-mail -->
              <!-- Lista E-mails -->
              <v-flex xs12>
                <v-list two-line>
                  <template v-for="(email, index) in computedClienteEmails">
                    <v-list-tile :key="email.IdItem || index" avatar>
                      <v-list-tile-avatar v-if="$vuetify.breakpoint.mdAndUp">
                        <v-icon class="grey lighten-1">mail</v-icon>
                      </v-list-tile-avatar>

                      <v-list-tile-content>
                        <v-list-tile-title>{{ email.Descricao }}</v-list-tile-title>
                        <span class="caption font-italic">{{ tipoEmailTexto(email.Tipo) }}</span>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-layout row>
                          <v-tooltip bottom v-if="email.IdItem">
                            <v-btn icon flat small class="mx-0" slot="activator" @click="editaEmail(email)">
                              <v-icon small>edit</v-icon>
                            </v-btn>
                            <span>Alterar</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <v-btn icon flat small class="mx-0" slot="activator" @click="deletaEmail(email)">
                              <v-icon small>delete</v-icon>
                            </v-btn>
                            <span>Excluir</span>
                          </v-tooltip>
                        </v-layout>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < clienteEmails.length"
                      :key="`${index}-${email.IdItem}`"
                    ></v-divider>
                  </template>
                </v-list>
              </v-flex>
              <!-- Fim Lista E-mails -->
              <!-- Observações -->
              <v-flex xs12>
                <span class="subheading font-weight-medium">Observações</span>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs12>
                <SharedTextarea
                  :value="cliente.Observacoes"
                  @change="v => cliente.Observacoes = v"
                  hide-details
                  outline
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Cliente from '@/domain/cliente/Cliente';
import ClienteEndereco from '@/domain/cliente/ClienteEndereco';
import ClienteTelefone from '@/domain/cliente/ClienteTelefone';
import ClienteEmail from '@/domain/cliente/ClienteEmail';
import SharedTextarea from '@/components/shared/Textarea';

export default {
  name: 'ModalCadastroCliente',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    cliente: {
      type: Object,
      default: () => new Cliente()
    },
    clienteEndereco: {
      type: Object,
      default: () => new ClienteEndereco()
    },
    clienteTelefone: {
      type: Object,
      default: () => new ClienteTelefone()
    },
    clienteEmail: {
      type: Object,
      default: () => new ClienteEmail()
    }
  },
  components: {
    SharedTextarea
  },
  data() {
    return {
      dialog: false,
      loading: false,
      tiposEndereco: [
        { IdTipoEndereco: 1, Descricao: 'RESIDENCIAL' },
        { IdTipoEndereco: 2, Descricao: 'TRABALHO' },
        { IdTipoEndereco: 3, Descricao: 'ENTREGA' },
        { IdTipoEndereco: 4, Descricao: 'COBRANCA' },
        { IdTipoEndereco: 5, Descricao: 'OUTROS' },
      ],
      buscaCepErro: false,
      buscaCepLoading: false,
      buscaCepRetorno: '',
      rules: {
        required: value => !!value || 'Campo obrigatório.',
        cep: value => value && value.length === 8 || 'CEP inválido.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Formato do e-mail inválido.';
        }
      },
      inputTelefone: false,
      tiposTelefone: [
        { IdTipoTelefone: 1, Descricao: 'GERAL' },
        { IdTipoTelefone: 2, Descricao: 'RESIDENCIAL' },
        { IdTipoTelefone: 3, Descricao: 'CELULAR' },
        { IdTipoTelefone: 4, Descricao: 'TRABALHO' },
        { IdTipoTelefone: 5, Descricao: 'WHATSAPP' },
        { IdTipoTelefone: 6, Descricao: 'OUTROS' },
      ],
      inputEmail: false,
      tiposEmail: [
        { IdTipoEmail: 1, Descricao: 'GERAL' },
        { IdTipoEmail: 3, Descricao: 'NFE' },
        { IdTipoEmail: 4, Descricao: 'FINANCEIRO' },
        { IdTipoEmail: 2, Descricao: 'COMERCIAL' },
        { IdTipoEmail: 6, Descricao: 'OUTROS' },
      ],
      telefonesAdicionar: [],
      emailsAdicionar: [],
    }
  },
  computed: {
    ...mapGetters(['clienteEnderecos', 'clienteTelefones', 'clienteEmails', 'clienteTags', 'clienteProjetos', 'bairrosAtivo', 'cidades']),
    statusColor() {
      if (this.cliente.Status.startsWith('A')) return "#263238";
      if (this.cliente.Status.startsWith('I')) return "info";
      if (this.cliente.Status.startsWith('C')) return "#bdbdbd";
    },
    statusText() {
      if (this.cliente.Status.startsWith('A')) return "Ativo";
      if (this.cliente.Status.startsWith('I')) return "Inativo";
      if (this.cliente.Status.startsWith('C')) return "Cancelado";
    },
    // dataNascimento: {
    //   get() {
    //     if (this.cliente && this.cliente.DataNascimento) {
    //       return new Date(this.cliente.DataNascimento).toISOString().substr(0, 10);
    //     } else {
    //       return new Date(1970, 0, 1, 0, 0, 0).toISOString().substr(0, 10);
    //     }
    //   },
    //   set(value) {
    //     this.changeclienteDatePicker(value);
    //   }
    // },
    computedTitle() {
      return this.cliente.IdCliente ? 'Editar Cliente' : 'Novo Cliente';
    },
    computedWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '100%';
        case 'sm': return '100%';
        case 'md': return '85%';
        case 'lg': return '60%';
        case 'xl': return '50%';
      }
    },
    computedTipoPessoa: {
      get() {
        return this.cliente.TipoPessoa.trim();
      },
      set(value) {
        this.cliente.TipoPessoa = value.trim();
      }
    },
    cpfCnpjMask() {
      if (this.cliente.TipoPessoa.startsWith('F')) return '###.###.###-##';
      return '##.###.###/####-##';
    },
    telefoneMask() {
      if (this.clienteTelefone.Descricao && this.clienteTelefone.Descricao[5] == 9) return '(##) # ####-####';
      if (this.clienteTelefone.Descricao && this.clienteTelefone.Descricao[5] != 9) return '(##) ####-####';
      return '(##) # ####-####';
    },
    computedStatus() {
      return this.cliente.Status.trim();
    },
    computedClienteTelefones() {
      if (this.clienteTelefones.length) return this.clienteTelefones;
      if (this.telefonesAdicionar.length) return this.telefonesAdicionar;
      return [];
    },
    computedClienteEmails() {
      if (this.clienteEmails.length) return this.clienteEmails;
      if (this.emailsAdicionar.length) return this.emailsAdicionar;
      return [];
    }
  },
  methods: {
    ...mapActions([
      'addCliente',
      'addClienteEndereco',
      'addClienteTelefone',
      'addClienteEmail',
      'updateCliente',
      'updateClienteEndereco',
      'updateClienteTelefone',
      'updateClienteEmail',
      'fetchBairros',
      'fetchCidades',
      'fetchProjetoById',
      'fetchItensProjetosNode',
      'deleteClienteTag',
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    // buscaCnpj() {
    //   let cnpj = this.cliente.CpfCnpj.replace('.', '').replace('/', '').replace('-', '');
    //   let url = `https://www.receitaws.com.br/v1/cnpj/${cnpj}`;
    //   fetch(url, {
    //     headers: {
    //       'Authorization': `Bearer e9ff4559d868663a9f292cb1c833efaddffc309593154c43804850410525b8ed`
    //     }
    //   })
    //     .then(res => res.json())
    //     .then(json => console.log(json))
    //     .catch(err => console.log(err.message));
    // },
    corStatus(status) {
      if (status.startsWith('A')) return "#263238";
      if (status.startsWith('F')) return "#1976d2";
      if (status.startsWith('C')) return "#bdbdbd";
    },
    buscaCep() {
      this.buscaCepLoading = true;
      let cep = this.clienteEndereco.Cep.replace('-', '');
      let url = `http://viacep.com.br/ws/${cep}/json`;
      fetch(url)
        .then(res => res.json())
        .then(json => {
          if (this.clienteEndereco.Endereco && confirm('Deseja substituir o endereço atual?')) {
            this.buscaCepErro = false;
            this.buscaCepRetorno = '';
            this.buscaCepLoading = false;
            return this.preencheCepAuto(json);
          } else {
            this.buscaCepErro = false;
            this.buscaCepRetorno = '';
            this.buscaCepLoading = false;
            return this.preencheCepAuto(json)
          }
        })
        .catch(err => {
          this.buscaCepRetorno = 'CEP não encontrado.';
          this.buscaCepErro = true;
          this.buscaCepLoading = false;
          console.log(err);
        });
    },
    preencheCepAuto(json) {
      if (typeof json == 'object') {
        const { logradouro, complemento, bairro, localidade } = json;
        this.clienteEndereco.Endereco = logradouro;
        this.clienteEndereco.Complemento = complemento;
        // Preenche bairro
        const bairroEncontrado = this.bairrosAtivo.find(b => this.converteStringParaComparacao(b.Descricao) == this.converteStringParaComparacao(bairro));
        if (bairroEncontrado) {
          this.clienteEndereco.IdBairro = bairroEncontrado.IdBairro;
          this.clienteEndereco.Bairro = bairroEncontrado.Descricao;
        }
        // Preenche cidade
        const cidadeEncontrada = this.cidades.find(c => this.converteStringParaComparacao(c.Descricao) == this.converteStringParaComparacao(localidade));
        if (cidadeEncontrada) {
          this.clienteEndereco.IdCidade = cidadeEncontrada.IdCidade;
          this.clienteEndereco.Cidade = cidadeEncontrada.Descricao;
        }
      } else {
        console.log('json inválido');
      }
    },
    converteStringParaComparacao(text) {
      const a = 'àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
      const b = 'aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
      const p = new RegExp(a.split('').join('|'), 'g')
      return text.toString().toLowerCase().trim()
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special chars
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[\s\W-]+/g, '-') // Replace spaces, non-word characters and dashes with a single dash (-)
    },
    tipoEmailTexto(tipo) {
      if (tipo && tipo.startsWith('G')) {
        return 'GERAL';
      } else if (tipo && tipo.startsWith('N')) {
        return 'NFE';
      } else if (tipo && tipo.startsWith('F')) {
        return 'FINANCEIRO';
      } else if (tipo && tipo.startsWith('C')) {
        return 'COMERCIAL';
      } else if (tipo && tipo.startsWith('O')) {
        return 'OUTROS';
      } else {
        return 'GERAL';
      }
    },
    tipoTelefoneTexto(tipo) {
      if (tipo && tipo.startsWith('G')) {
        return 'GERAL';
      } else if (tipo && tipo.startsWith('R')) {
        return 'RESIDENCIAL';
      } else if (tipo && tipo.startsWith('C')) {
        return 'CELULAR';
      } else if (tipo && tipo.startsWith('T')) {
        return 'TRABALHO';
      } else if (tipo && tipo.startsWith('W')) {
        return 'WHATSAPP';
      } else if (tipo && tipo.startsWith('O')) {
        return 'OUTROS';
      } else {
        return 'GERAL';
      }
    },
    // Tags
    async excluiTag(tag) {
      if (confirm(`Remover: ${tag.Descricao}?`)) {
        this.loading = true;
        try {
          await this.deleteClienteTag(tag);
          this.showNotification({ text: `Tag excluida com sucesso.`, status: 'success' });
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.showNotification({ text: `Ocorreu um erro ao excluir a tag: ${error}`, status: 'error' });
        }
      }
    },
    // Endereços
    addNewEndereco() {
      this.$emit('addNewEndereco');
      this.$nextTick(() => document.getElementById('cep').focus());
    },
    changeEndereco(obj) {
      this.$emit('changeEndereco', obj);
    },
    changeTipoEndereco(obj) {
      this.clienteEndereco.IdTipoEndereco = obj.IdTipoEndereco;
      this.clienteEndereco.TipoEndereco = obj.Descricao[0];
      this.clienteEndereco.Titulo = obj.Descricao;
    },
    changeBairro(obj) {
      this.clienteEndereco.IdBairro = obj.IdBairro;
      this.clienteEndereco.Bairro = obj.Descricao;
    },
    changeCidade(obj) {
      this.clienteEndereco.IdCidade = obj.IdCidade;
      this.clienteEndereco.Cidade = obj.Descricao;
    },
    // E-mails
    mostraInputEmail() {
      this.inputEmail = true;
      this.$nextTick(() => document.getElementById('email-add-item').focus());
    },
    editaEmail(email) {
      this.$emit('editaEmail', email);
      this.inputEmail = true;
      this.$nextTick(() => document.getElementById('email-add-item').focus());
    },
    cancelaEditaEmail() {
      this.$emit('cancelaEditaEmail');
      this.inputEmail = false;
    },
    deletaEmail(email) {
      if (email.IdItem) {
        this.$emit('deleteEmail', email)
      } else {
        this.emailsAdicionar = this.emailsAdicionar.filter(email => email.Descricao !== email.Descricao);
      }
    },
    async adicionaEmailsPendentes(idCliente) {
      if (this.emailsAdicionar.length) {
        for (const email of this.emailsAdicionar) {
          email.IdCliente = idCliente;
          await this.addClienteEmail(email)
        }
        this.emailsAdicionar = [];
      } else {
        return;
      }
    },
    async adicionaEmail() {
      if (!this.clienteEmail.IdItem && this.clienteEmail.Descricao) {
        const newClienteEmail = Object.assign({}, this.clienteEmail);
        newClienteEmail.Tipo = newClienteEmail.Tipo[0];
        // Verifica se o cliente já está cadastrado
        if (this.cliente.IdCliente) {
          newClienteEmail.IdCliente = this.cliente.IdCliente;
        } else {
          this.emailsAdicionar.push(newClienteEmail);
          this.$nextTick(() => document.getElementById('email-add-item').focus());
          return this.$emit('emailAdicionado');
        }
        try {
          this.loading = true;
          await this.addClienteEmail(newClienteEmail);
          this.$emit('emailAdicionado');
          this.showNotification({ text: 'E-mail adicionado com sucesso.', status: 'success' });
          this.$nextTick(() => document.getElementById('email-add-item').focus());
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.showNotification({ text: `Ocorreu um erro ao adicionar o e-mail: ${error}.`, status: 'error' });
        }
      } else if (this.clienteEmail.IdItem && this.clienteEmail.Descricao) {
        this.loading = true;
        const updClienteEmail = Object.assign({}, this.clienteEmail);
        updClienteEmail.Tipo = updClienteEmail.Tipo[0];
        try {
          await this.updateClienteEmail(updClienteEmail);
          this.loading = false;
          this.$emit('emailAdicionado');
          this.showNotification({ text: 'E-mail atualizado com sucesso.', status: 'success' });
          this.inputEmail = false;
        } catch (error) {
          this.loading = false;
          this.showNotification({ text: `Ocorreu um erro ao atualizar o email: ${error}.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Informe o email.', status: 'error' });
      }
    },
    // Telefones
    mostraInputTelefone() {
      this.inputTelefone = true;
      this.$nextTick(() => document.getElementById('telefone-add-item').focus());
    },
    editaTelefone(telefone) {
      this.$emit('editaTelefone', telefone);
      this.inputTelefone = true;
      this.$nextTick(() => document.getElementById('telefone-add-item').focus());
    },
    cancelaEditaTelefone() {
      this.$emit('cancelaEditaTelefone');
      this.inputTelefone = false;
    },
    deletaTelefone(telefone) {
      if (telefone.IdClienteTelefone) {
        this.$emit('deleteTelefone', telefone)
      } else {
        this.telefonesAdicionar = this.telefonesAdicionar.filter(telefone => telefone.Descricao !== telefone.Descricao);
      }
    },
    async adicionaTelefonesPendentes(idCliente) {
      if (this.telefonesAdicionar.length) {
        for (const telefone of this.telefonesAdicionar) {
          telefone.IdCliente = idCliente;
          await this.addClienteTelefone(telefone)
        }
        this.telefonesAdicionar = [];
      } else {
        return;
      }
    },
    async adicionaTelefone() {
      if (!this.clienteTelefone.IdClienteTelefone && this.clienteTelefone.Descricao && this.clienteTelefone.Contato) {
        const newClienteTelefone = Object.assign({}, this.clienteTelefone);
        newClienteTelefone.TipoTelefone = newClienteTelefone.TipoTelefone[0];
        // Verifica se o cliente já está cadastrado
        if (this.cliente.IdCliente) {
          newClienteTelefone.IdCliente = this.cliente.IdCliente;
        } else {
          this.telefonesAdicionar.push(newClienteTelefone);
          this.$nextTick(() => document.getElementById('telefone-add-item').focus());
          return this.$emit('telefoneAdicionado');
        }
        try {
          this.loading = true;
          await this.addClienteTelefone(newClienteTelefone);
          this.$emit('telefoneAdicionado');
          this.showNotification({ text: 'Telefone adicionado com sucesso.', status: 'success' });
          this.$nextTick(() => document.getElementById('telefone-add-item').focus());
          this.loading = false;
        } catch (error) {
          this.loading = false;
          this.showNotification({ text: `Ocorreu um erro ao adicionar o telefone: ${error}.`, status: 'error' });
        }
      } else if (this.clienteTelefone.IdClienteTelefone && this.clienteTelefone.Descricao && this.clienteTelefone.Contato) {
        this.loading = true;
        const updClienteTelefone = Object.assign({}, this.clienteTelefone);
        updClienteTelefone.TipoTelefone = updClienteTelefone.TipoTelefone[0];
        try {
          await this.updateClienteTelefone(updClienteTelefone);
          this.loading = false;
          this.$emit('telefoneAdicionado');
          this.showNotification({ text: 'Telefone atualizado com sucesso.', status: 'success' });
          this.inputTelefone = false;
        } catch (error) {
          this.loading = false;
          this.showNotification({ text: `Ocorreu um erro ao atualizar o telefone: ${error}.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Informe o telefone e o contato.', status: 'error' });
      }
    },
    async adiciona() {
      if (!this.cliente.IdCliente && this.cliente.RazaoSocial) {
        this.loading = true;
        const newCliente = Object.assign({}, this.cliente);
        const newClienteEndereco = Object.assign({}, this.clienteEndereco);
        try {
          const id = await this.addCliente(newCliente);
          newClienteEndereco.IdCliente = id;
          await this.addClienteEndereco(newClienteEndereco);
          await this.adicionaTelefonesPendentes(id);
          await this.adicionaEmailsPendentes(id);
          this.showNotification({ text: `Cliente: ${newCliente.RazaoSocial} adicionado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('clienteAdicionado');
        } catch (error) {
          this.loading = false;
          this.showNotification({ text: `Ocorreu um erro ao adicionar o cliente: ${error}.`, status: 'error' });
        }
      } else if (this.cliente.IdCliente && this.cliente.RazaoSocial) {
        this.loading = true;
        const updCliente = Object.assign({}, this.cliente);
        const updClienteEndereco = Object.assign({}, this.clienteEndereco);
        try {
          await this.updateCliente(updCliente);
          if (this.clienteEndereco.IdCliente && this.clienteEndereco.IdItem) {
            await this.updateClienteEndereco(updClienteEndereco);
          } else {
            updClienteEndereco.IdCliente = this.cliente.IdCliente;
            await this.addClienteEndereco(updClienteEndereco);
          }
          this.showNotification({ text: `Cliente: ${updCliente.RazaoSocial} atualizado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('clienteAdicionado');
        } catch (error) {
          this.loading = false;
          this.showNotification({ text: `Ocorreu um erro ao atualizar o cliente: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Razão Social do cliente.`, status: 'error' });
      }
    }
  },
  async created() {
    if (!this.bairrosAtivo.length) {
      await this.fetchBairros();
    }
    if (!this.cidades.length) {
      await this.fetchCidades();
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.pos-abs-fixed {
  z-index: 2;
  position: relative;
  padding-bottom: 40px;
}

.pos-abs-fixed > :first-child {
  position: fixed;
  width: 49.4%;
}

@media screen and (max-width: 1903px) and (min-width: 1264px) {
  .pos-abs-fixed > :first-child {
    width: 59.4%;
  }
}

@media screen and (max-width: 1263px) and (min-width: 960px) {
  .pos-abs-fixed > :first-child {
    width: 84.4%;
  }
}

@media screen and (max-width: 959px) {
  .pos-abs-fixed > :first-child {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1rem !important;
  }
}
</style>